import { useTypewriter } from 'react-simple-typewriter'
import { Block, H1, Image, Text } from '@mote/ui/components'
import styled, { th } from '@xstyled/styled-components'
import { CTABlock, Container } from './shared'

export const HeroSection = (): JSX.Element => {
  const { text } = useTypewriter({
    words: ['feedback', 'connection', 'accessibility', 'language'],
    loop: 0
  })

  return (
    <Root>
      <TextContainer>
        <Title>
          Level up{' '}
          <Text tag='span' color='primary.base'>
            {text}
          </Text>
        </Title>
        <Subtitle>
          Mote is the audio toolkit for educators and learners across the world
          - integrated into the products you know and love.
        </Subtitle>
        <CTABlock />
      </TextContainer>
      <HeroContainer>
        <ImageContainer>
          <HeroImage
            src='https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3).png'
            loading='lazy'
            width='100'
            srcSet='https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3)-p-500.png 500w, https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3)-p-800.png 800w, https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3)-p-1080.png 1080w, https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3)-p-1600.png 1600w, https://uploads-ssl.webflow.com/62601a2f1ad4af5dee4bd21e/62d51841fc49d7d0eb009dc4_Feedback%20Hero%20(3).png 2220w'
            sizes='(max-width: 991px) 90vw, 70vw'
            alt='Mote for connection'
          />
        </ImageContainer>
      </HeroContainer>
    </Root>
  )
}

const Root = styled.div`
  background-color: ${th.color('grey.l4')};
`

const TextContainer = styled(Container)`
  padding-top: 5%;
  padding-bottom: 5%;

  @media (max-width: 991px) {
    gap: 20px;
  }

  @media (max-width: 767px) {
    gap: 18px;
  }

  @media (max-width: 479px) {
    gap: 12px;
  }
`

const Title = styled(H1).attrs({
  color: 'black',
  lineHeight: '120%',
  fontWeight: 400
})`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 76px;
  height: auto;
  margin-bottom: 20px;

  @media (max-width: 991px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
    font-size: 60px;
    height: 154px;
    margin-bottom: 0;
  }

  @media (max-width: 767px) {
    font-size: 51px;
    height: 140px;
  }

  @media (max-width: 479px) {
    font-size: 36px;
    height: 130px;
  }
`

const Subtitle = styled(Text).attrs({
  tag: 'p',
  color: 'grey.d2',
  fontWeight: 400,
  lineHeight: '150%',
  alignment: 'center'
})`
  width: 600px;
  font-size: 18px;

  @media (max-width: 767px) {
    font-size: 16px;
    width: 90%;
  }
`

const HeroContainer = styled(Block).attrs({
  align: 'center',
  height: 'auto',
  padding: '0 0 80px 0'
})``

const ImageContainer = styled.div`
  width: 70%;
  max-width: 1200px;

  @media (max-width: 991px) {
    width: 90%;
  }
`

const HeroImage = styled(Image)`
  width: 100%;
  max-width: 100%;
  border-radius: 24px;
`
